import { useTrips } from '../api'

/**
 * Returns true if user has any trip items
 */

export function useHasTripItems(): boolean {
  const { data: trips, isFetched } = useTrips()
  return (
    (isFetched && trips && trips.some((trip) => trip.itemCount > 0)) ?? false
  )
}
